<form class="form" [formGroup]="loginForm" (submit)="onSubmit()">
  <div class="form-wrapper">
    <!-- FORM INPUTS -->
    <div class="row is-flex">
      <div class="col">
        <mat-form-field>
          <input matInput name="username" placeholder="Email Address" formControlName="username" required />
          @if (username.errors?.required) {
          <mat-error> <fa-icon icon="exclamation-triangle"></fa-icon> Email address is required. </mat-error>
          } @if (!username.errors?.required && username.errors?.email) {
          <mat-error> <fa-icon icon="exclamation-triangle"></fa-icon> Invalid Email address. </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col">
        <mat-form-field>
          <input matInput type="password" name="password" placeholder="Password" formControlName="password" required />
          @if (password.errors?.required) {
          <mat-error> <fa-icon icon="exclamation-triangle"></fa-icon> Password is required. </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <!-- INVALID CREDENTIALS MESSAGE -->
    <div class="row">
      <div class="col s12">
        @if ((error$ | async)) {
        <p class="text-semibold text-block text-warn mb-20">
          <fa-icon icon="exclamation-triangle"></fa-icon> Email or password are invalid, please try again.
        </p>
        }
      </div>
    </div>

    <!-- ACTIONS -->
    <div class="row is-flex">
      <div class="col mb-20">
        <button cdkFocusInitial class="btn btn-primary" name="login" type="submit" [disabled]="pending$ | async">
          Login @if ((pending$ | async)) {
          <fa-icon icon="spinner" [spin]="true"></fa-icon>
          }
        </button>
      </div>
      <div class="col mb-20 is-flex-centered">
        <mat-hint><span routerLink="/auth/essiloradmin">Login as Essilor Employee</span></mat-hint>
      </div>
      <!--      <div class="col mb-20">-->
      <!--        <a routerLink="/reset-password" class="btn btn-link">Forgot Password?</a>-->
      <!--      </div>-->
    </div>
  </div>
</form>
